import { createFileRoute } from '@tanstack/react-router'

import GuestOrdersPage from '@/views/orders/pages/guest.orders.page'

export const Route = createFileRoute('/phong-nha/guest/orders/')({
  component: GuestOrdersPage,
})
